import React from 'react';
import { Button } from '../ui/button';

interface DeleteConfirmationModalProps {
  show: boolean;
  projectName: string;
  onCancel: () => void;
  onConfirm: () => void;
  titleText?: string;
  confirmText?: string;
  descriptionText?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ show, projectName, onCancel, onConfirm, titleText, confirmText, descriptionText }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative flex flex-col items-center">
        <h2 className="text-lg font-bold mb-4 text-red-600 text-center w-full">{titleText || 'Delete Project'}</h2>
        <p className="mb-2 text-center w-full">{descriptionText || 'Are you sure you want to delete the project?'}</p>
        <div className="mb-6 text-center font-semibold text-custom-blue-900 w-full">"{projectName}"</div>
        <p className="mb-6 text-center w-full">This action cannot be undone.</p>
        <div className="flex flex-col gap-2 items-center w-full">
          <Button variant="outline" className="w-full" onClick={onCancel}>Cancel</Button>
          <Button variant="destructive" className="w-full" onClick={onConfirm}>{confirmText || 'Delete'}</Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
